import React from 'react';

export default function NotFound() {
    return (
        <div>
             pages are not found!
        </div>
    );
}

